<template>
  <div class="d-flex">
    <div class="score-meter my-auto">
      <ScoreMeter :score="score" />
    </div>

    <div class="ml-6 flex-grow-1 d-flex flex-column justify-center">
      <div>
        <EstimatedCandidatesDropdown
          :job-id="jobId"
          :specificity-key="specificityKey"
          :specificity-data="specificityData"
          :hide-tooltip-icon="hideTooltipIcon"
          @tracking-event="$emit('track-sidebar-event', $event)"
        />
      </div>

      <ScalesBlock
        v-if="!inclusionMeterDisabled"
        class="mt-2"
        :scales="scales"
      />

      <WordCount
        v-if="wordCount"
        class="mt-2"
        :word-count="wordCount"
      />
    </div>
  </div>
</template>

<script setup>
import ScoreMeter from '@/components/editor/ScoreMeter.vue';
import ScalesBlock from '@/components/editor/ScalesBlock.vue';
import EstimatedCandidatesDropdown from '@/components/editor/EstimatedCandidatesDropdown.vue';
import WordCount from '@/components/editor/WordCount.vue';

defineProps({
  jobId: { type: [String, Number], required: true },
  score: { type: Number, default: 0 },
  wordCount: { type: Number, default: 0 },
  scales: { type: Object, default: () => ({}) },
  specificityKey: { type: Number, default: 0 },
  specificityData: { type: Object, default: () => ({}) },
  inclusionMeterDisabled: { type: Boolean, default: false },
  hideTooltipIcon: { type: Boolean, default: false },
});

defineEmits(['track-sidebar-event']);
</script>

<style scoped lang="less">
.score-meter {
  height: 54px;
  width: 54px;
  &:deep(.score-meter-container) {
    svg#circle-two {
      width: 100%;
      height: 100%;
    }
    h1 {
      line-height: 58px;
      top: 0;
      font-size: 20px;
      font-weight: 600;
    }
  }
}
</style>
